import React, { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Checkbox } from '@agro-club/frontend-shared'
import { DiscountRuleScope } from 'modules/domain/discountRule/types'

const Title = styled.div`
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  opacity: 0.48;
  white-space: nowrap;
`
const Wrapper = styled.div`
  display: flex;
`

const Item = styled.div`
  &:last-child {
    margin-left: 20px;
  }
`

type PropsType = {
  onChange: (scope: DiscountRuleScope, on: boolean) => void
  scopes?: DiscountRuleScope[]
}
export const DiscountScopesSwitcher: FC<PropsType> = ({ onChange, scopes }: PropsType) => {
  const { t } = useTranslation('discountRules')
  const handleChangeDiscountScope = useCallback(
    (field: DiscountRuleScope) => (_: unknown, isChecked: boolean) => {
      onChange(field, isChecked)
    },
    [onChange],
  )

  return (
    <div>
      <Title>{t('form.discountFor')}</Title>
      <Wrapper>
        <Item>
          <Checkbox
            label={t('form.labels.farmer')}
            isChecked={scopes?.includes(DiscountRuleScope.FarmerOrders)}
            onChange={handleChangeDiscountScope(DiscountRuleScope.FarmerOrders)}
            testId={'discount-scope-farmer'}
          />
        </Item>
        <Item>
          <Checkbox
            label={t('form.labels.distributor')}
            isChecked={scopes?.includes(DiscountRuleScope.DistributorOrder)}
            onChange={handleChangeDiscountScope(DiscountRuleScope.DistributorOrder)}
            testId={'discount-scope-distributor'}
          />
        </Item>
      </Wrapper>
    </div>
  )
}
